export enum CocPageType {
  landing = 'landing',
  dashboard = 'dashboard',
}
